import { getRoleName } from "./helpers";

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }

    const parsedState = JSON.parse(serializedState);
    parsedState.authReducer.roleName = getRoleName(parsedState.authReducer.idToken);

    return parsedState;
  } catch (error) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);
  } catch (error) {
    //TODO: errors handling
  }
};
